<template>
    <div>

    <v-tooltip left dark>
        <template #activator='data'>
            <v-btn text icon  @click="newObject(list[tab].code)">
                <v-icon medium=""  color="success" v-on="data.on">mdi-plus</v-icon>
            </v-btn>
        </template>
        <span>{{ list[tab].description }} toevoegen</span>
    </v-tooltip>                
    
    <v-dialog 
      v-model="createObject.show"
      width="500">
      <material-card>
      <p class="subheading text-center">{{list[tab].category.description}} toevoegen</p>

      <v-container v-if="list[tab].category.code == 'WO'">
        
        <v-layout row>
          <v-flex xs11 offset-xs1>
            <p>Adres zoeken</p>
          </v-flex>
        </v-layout>  
        <v-layout row>
          <v-flex xs4 offset-xs1>
            <v-text-field v-model="postcode" label="Postcode"></v-text-field>
          </v-flex>
          <v-flex xs3 offset-xs1>
            <v-text-field v-model="huisnummer" label="Huisnummer"></v-text-field>
          </v-flex>
          
        
        </v-layout>

        <v-layout fill-height="" justify-center="" align-center="" style="min-height:24px;">
          <v-flex v-if="count > 0" align-center="" offset-xs1 >
            <span class="caption">aantal gevonden objecten : </span>
            <span :class="{'warning--text' : count > 9, 'error--text': count == 0, 'success--text' : count < 9 && count > 0}" class="font-weight-bold caption text-center">{{count}}</span>           
          </v-flex>
        </v-layout>        


        <v-autocomplete
          v-model="model"
          :items="entries"
          :color="app.color"
          hide-no-data
          hide-selected
          item-text="weergavenaam"
          item-value='id'
          label="Adres"
          prepend-icon="mdi-database-search"
        >
        <template v-slot:append-outer v-if="model != null">
          <v-slide-x-reverse-transition
            mode="out-in"
          >
            <v-icon
              color="error"
              
              @click="model = null"
            >mdi-minus</v-icon>
          </v-slide-x-reverse-transition>
        </template>          
        </v-autocomplete>      

          
      </v-container>

      <v-layout justify-center="" style="min-height:54px;" v-if="list[tab].category.code == 'WO'">
        <v-expand-transition>
          <v-layout justify-center="">
            <v-flex xs8>
              <v-btn rounded block color="success" v-if="model != null && validObject  " @click="getKadasterData(model, list[tab].category.reference)">{{list[tab].category.description}} aanmaken</v-btn>
              <v-btn rounded block color="success" :disabled="!validObject" v-if="model != null && !validObject">{{list[tab].category.description}} bestaat al</v-btn>
            </v-flex>
          </v-layout>
        </v-expand-transition>
      </v-layout>
      </material-card>
    </v-dialog>  
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    entries: [],
    isLoading: false,
    model: null,
    kadasterSearch: "",
    huisnummer: "",
    postcode: "",
    count: null,
    object: {},
    button_text: "Aanmaken"
  }),
  props: {
    tab: {
      type: Number,
      default: undefined
    },
    list: {
      type: Array,
      default: undefined,
      required: true
    }
  },
  methods: {
    newObject(code) {
      this.$store.dispatch("newObject", {
        code: code
      });
    },
    fetchKadaster() {
      return this.entries;
    },
    getKadasterData(id, type) {
      this.$store.dispatch("createKadasterObject", {
        id: id,
        reference: type
      });
      (this.huisnummer = ""), (this.postcode = ""), (this.model = null);
    }
  },
  computed: {
    ...mapState(["user", "app", "createObject"]),
    // ...mapGetters(["list"]),
    query() {
      return (
        "https://geodata.nationaalgeoregister.nl/locatieserver/v3/suggest?q=" +
        this.postcode +
        "+" +
        this.huisnummer
      );
    },
    validObject() {
      if (
        this.$store.getters.checkExistObject(this.model, "adr_id") == undefined
      ) {
        return true;
      } else {
        this.button_text = "";
        return false;
      }
    }
  },
  watch: {
    query() {
      // Items have already been loaded
      // if (this.items.length > 0) return;

      // Items have already been requested
      // if (this.isLoading) return;

      this.isLoading = true;

      fetch(this.query)
        .then(res => res.json())
        .then(res => {
          var docs = res.response.docs.filter(item => item.type == "adres");
          this.entries = docs;
          this.count = res.response.numFound;
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>

